// extracted by mini-css-extract-plugin
export var text = "_87-0";